import React, {
    useState, useEffect, useCallback, useContext, useMemo
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { useAuthentication } from 'gw-digital-auth-react';
import { ServiceRequestService } from 'gw-capability-servicerequest';

import {
    Loader, ModalNextProvider, FormattedDate, Button
} from '@jutro/components';
import { Link, Currency as CurrencyField } from 'gw-components-platform-react';
import metadata from './SasriaBankDetailsPage.metadata.json5';
import styles from './SasriaBankDetailsPage.module.scss';
import messages from './SasriaBankDetailsPage.messages';
import { FileUtil } from 'gw-portals-util-js';
import { DocumentComponent, documentMessages } from 'gw-capability-document-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { messages as commonMessages } from 'gw-platform-translations';
import BankDetails from './Model/BankDetails';


function SasriaBankDetailsPage(props) {
    const { match } = props;
    const { params } = match;
    const { serviceRequestNumber } = params;
    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();
    const [isLoading, setLoadingState] = useState(false);
    const [bankDataArray, setBankDataArray] = useState([]);
    const [bankData, setBankData] = useState({ cardArray: [] });
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const userData = useAuthentication();
    const [addNewDetails, setAddNewDetails] = useState(false);
    const [bankNamesArray, setBankNamesArray] = useState([]);
    const [selectedBankName, setSelectedBankName] = useState('');
    const [selectedAccountType, setSelectedAccountType] = useState('current_EXT');
    const [selectedIsPrimary, setSelectedIsPrimary] = useState('Yes');
    const [disableAddButton, isAddButtonDisabled] = useState(true);
    const [fetched, isFetched] = useState(false);
    const [bankStatus, setBankStatus] = useState('');
    const [AVSValidated, isAVSValidated] = useState(true);
    const [indexArray, setIndexArray] = useState([]);
    const [targetId, setTargetId] = useState('');
    const [existingDocumentList, setExistingDocumentList] = useState([]);
    //const [bankVM, setBankVM] = useState({});

    const bankViewModel = viewModelService.create(
        new BankDetails(),
        'cc',
        'edge.capabilities.servicerequest.dto.BankServiceDTO_EXT'
    );
    const [bankVM] = useState(bankViewModel);

    const displayEFTRecords = useCallback(
        () => {
            setLoadingState(true);
            if (bankDataArray && bankDataArray.length >= 1) {
                return bankDataArray;
            }
            return ServiceRequestService.getEFTRecords_EXT(authHeader)
                .then((response) => {
                    setBankDataArray([]);
                    response.forEach((value) => {
                        const { status } = value;
                        bankDataArray.push(value);
                        setBankStatus(status);
                    });
                    setBankDataArray(bankDataArray);
                    _.set(bankVM.value, 'cardArray', bankDataArray);
                    bankVM.cardArray = bankDataArray;
                    isFetched(true);
                })
                .finally(() => {
                    setLoadingState(false);
                });
        }, [authHeader, bankDataArray, bankVM]
    );

    const getCodefilter = useCallback((retrievedList) => {
        return retrievedList.map((key) => {
            return {
                code: key,
                name: key
            };
        });
    }, []);

    const displayBankNames = useCallback(
        () => {
            if (bankNamesArray && bankNamesArray.length >= 1) {
                return bankNamesArray;
            }
            return ServiceRequestService.populateSariaBankNames(authHeader)
                .then((bankNames) => {
                    const bankNamesList = getCodefilter(bankNames);
                    setBankNamesArray(bankNamesList);
                });
        },
        [authHeader, bankNamesArray, getCodefilter],
    );
    const checkingAVSValidation = useCallback(
        () => {
            return ServiceRequestService.checkingValidationForAVS(authHeader)
                .then((response) => {
                    isAVSValidated(response);
                });
        },
        [authHeader],
    );

    const addBankAccount = useCallback(
        () => {
            displayBankNames();
            //checkingAVSValidation();
            setAddNewDetails(!addNewDetails);
            //const contactId =  await ServiceRequestService.retrieveTargetId_EXT(authHeader)
            bankVM.bankName = '';
            _.set(bankVM, 'bankName', '');
            _.set(bankVM, 'accountName', '');
            bankVM.accountType = 'current_EXT';
            setSelectedAccountType('current_EXT');
            setSelectedIsPrimary('Yes');
            setSelectedBankName('');
            bankVM.accountNumber = '';
            bankVM.branchCode = '';
            bankVM.accountName = '';
            bankVM.isPrimary = 'Yes';
            _.set(bankVM.value, 'isPrimary', true);
        },
        [addNewDetails, bankVM, checkingAVSValidation, displayBankNames],
    );


    const populateBankCode = useCallback(
        (bankname) => {
            ServiceRequestService.populateSariaBranchCodeForBankName_EXT(bankname, authHeader)
                .then((branchcodePopulated) => {
                    if (!_.isEmpty(branchcodePopulated)) {
                        _.set(bankVM, 'branchCode', branchcodePopulated);
                        _.set(bankVM.value, 'branchCode', branchcodePopulated);
                    }
                    else {
                        _.set(bankVM, 'branchCode', '');
                        _.set(bankVM.value, 'branchCode', '');
                    }
                    refreshData();
                });
        },
        [authHeader, bankVM, refreshData]
    );

    const populateBankNames = useCallback(
        (bankName) => {
            _.set(bankVM.value, 'bankName', bankName);
            setSelectedBankName(bankName);
            populateBankCode(bankName);
        },
        [bankVM, populateBankCode],
    );

    const handleError = (title, message) => {
        return ModalNextProvider.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };

    const handleAddButton = useCallback(
        () => {
            const accountNumber = _.get(bankVM, 'accountNumber').value;
            const accountType = _.get(bankVM, 'accountType').value;
            const branchCode = _.get(bankVM, 'branchCode').value;
            const bankName = _.get(bankVM, 'bankName').value;
            const isPrimary = _.get(bankVM, 'isPrimary').value;
            const publicId = _.get(bankVM, 'publicId').value;
            const accountName = _.get(bankVM, 'accountName').value;
            if (AVSValidated === false) {
                return handleError(
                    messages.AVSValidationTitle,
                    messages.AVSValidationMessage
                );
            }
            if (_.isUndefined(accountNumber) || _.isEmpty(accountNumber)) {
                return handleError(
                    messages.bankAccNumMandatoryTitle,
                    messages.bankAccNumMandatoryMessage
                );
            }

            const regRegex = new RegExp(/^(\d{1,13})?$/);
            if (!_.isUndefined(accountNumber) && !regRegex.test(accountNumber)) {
                //_.set(insuredCriteria, 'regNo', undefined);
                return handleError(
                    messages.invalidBankTitle,
                    messages.invalidBankMessage
                );
            }

            if (_.isUndefined(accountType) || _.isEmpty(accountType)) {
                return handleError(
                    messages.bankAccTypeMandatoryTitle,
                    messages.bankAccTypeMandatoryMessage
                );
            }

            if (_.isUndefined(branchCode) || _.isEmpty(branchCode)) {
                return handleError(
                    messages.bankCodeNumMandatoryTitle,
                    messages.bankCodeNumMandatoryMessage
                );
            }

            if (_.isUndefined(bankName) || _.isEmpty(bankName)) {
                return handleError(
                    messages.bankNameMandatoryTitle,
                    messages.bankNameMandatoryMessage
                );
            }

            const bankValue = {
                accountNumber, accountType, branchCode, bankName, isPrimary, publicId, accountName
            };
            if (!_.isUndefined(indexArray) && !_.isEmpty(indexArray) && indexArray.length > 0) {
                const updatedList = indexArray.filter((value) => value !== publicId);
                setIndexArray(updatedList);
            }

            return ServiceRequestService.addNewBankAccount_EXT(bankVM.value, authHeader)
                .then(() => {
                    // const { status } = savedBankData;
                    bankDataArray.push(bankValue);
                    setBankDataArray(bankDataArray);
                    _.set(bankVM.value, 'cardArray', bankDataArray);
                    setAddNewDetails(!addNewDetails);
                    setBankStatus('The presented bank information is pending approval by a Sasria Claims Supervisor');
                }).finally(() => {
                    window.location.reload(true);
                });
        },
        [AVSValidated, addNewDetails, authHeader, bankDataArray, bankVM, indexArray],
    );

    const handleAccountType = useCallback(
        (accountType) => {
            _.set(bankVM.value, 'accountType', accountType);
            setSelectedAccountType(accountType);
            refreshData();
        },
        [bankVM.value, refreshData],
    );

    const handlePrimaryAccount = useCallback(
        (isPrimarySelected) => {
            const isPrimaryBoolean = isPrimarySelected === 'Yes' ? true : false;
            _.set(bankVM.value, 'isPrimary', isPrimaryBoolean);
            setSelectedIsPrimary(isPrimarySelected);
            refreshData();
        },
        [bankVM.value, refreshData],
    );

    const writeValue = useCallback(
        (value, path) => {
            _.set(bankVM, path, value);
            _.set(bankVM.value, path, value);
            refreshData();
            //(bankVM);
        },
        [bankVM, refreshData]
    );

    const fileMimeTypeMap = {
        csv: 'application/csv',
        doc: 'application/msword',
        msg: 'application/vnd.ms-outlook',
        eml: 'message/rfc822',
        zip: 'application/x-zip-compressed',
        pdf: 'application/pdf',
        ps: 'application/postscript',
        rtf: 'application/rtf',
        xls: 'application/vnd.ms-excel',
        ppt: 'application/vnd.ms-powerpoint',
        pps: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        wav: 'audio/wav',
        wma: 'audio/x-ms-wma',
        bmp: 'image/bmp',
        gif: 'image/gif',
        jpg: 'image/jpeg',
        tiff: 'image/tiff',
        tif: 'image/tiff',
        mdi: 'image/vnd.ms-modi',
        png: 'image/png',
        html: 'text/html',
        htm: 'text/html',
        txt: 'text/plain',
        rtx: 'text/richtext',
        xml: 'text/xml',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
        mov: 'video/quicktime',
        avi: 'video/x-msvideo',
        mp4: 'video/mp4'
    };

    const getFileExtension = useCallback((name) => {
        const extension = name.split('.').pop();
        return extension || '';
    }, []);

    const getMimeType = useCallback((name) => {
        const fileExtension = getFileExtension(name);
        let mimeType = _.get(fileMimeTypeMap, fileExtension);
        if (_.isNil(mimeType)) {
            mimeType = 'application/octet-stream';
        }
        return mimeType;
    }, [fileMimeTypeMap, getFileExtension]);

    const handleUploadDocument = useCallback(async (file) => {
        setLoadingState(true);
        const documentsArray = _.get(bankVM, 'documents.value', []);
        const fileName = FileUtil.checkFileName(file.name,
            [...documentsArray]);
        const documentMetadataTemplate = {
            DocUID: fileName,
            //contactId: targetId,
            contactId: await ServiceRequestService.retrieveTargetId_EXT(authHeader),
            name: fileName,
            // mimeType: file.type,
            mimeType: getMimeType(file.name),
            visibleToVendor_EXT: true,
            sessionID: await ServiceRequestService.generateUploadToken(authHeader)
        };
        ServiceRequestService.uploadDocumentForVendorInCM(file, documentMetadataTemplate, authHeader)
            .then((data) => {
                _.set(bankVM, 'documents.value', [...documentsArray, data]);
                existingDocumentList.push(data.publicID);
                setExistingDocumentList(existingDocumentList);
                // _.set(bankVM, 'existingDocumentsToLink.value', [...existingDocumentList, data.publicID]);
                refreshData();
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.documentUploadFailed,
                    message: messages.documentCannotBeUploaded,
                    status: 'error',
                    icon: 'mi-error-outline'
                });
            }).finally(() => {
                setLoadingState(false);
            });
    }, [authHeader, bankVM, existingDocumentList, refreshData]);

    const handleDeleteDocument = useCallback(async (publicID) => {
        setLoadingState(true);
        const contactId = await ServiceRequestService.retrieveTargetId_EXT(authHeader);
        await ServiceRequestService.removeVendorDocument_EXT(contactId, publicID, authHeader)
            .then((isDeleteItem) => {
                if (isDeleteItem) {
                    const uploadedDocuments = _.get(bankVM, 'documents.value');
                    // eslint-disable-next-line max-len
                    const modifiedDocuments = uploadedDocuments.filter((doc) => doc.publicID !== publicID);
                    _.set(bankVM, 'documents.value', modifiedDocuments);
                    // const uploadedDocLinks = _.get(bankVM, 'existingDocumentsToLink.value');
                    //const modifiedDocLinks = uploadedDocLinks.filter((id) => id !== publicID);
                    const modifiedExistingList = existingDocumentList.filter((id) => id !== publicID);
                    setExistingDocumentList(modifiedExistingList);
                    // _.set(bankVM, 'existingDocumentsToLink.value', modifiedDocLinks);
                    refreshData();
                }
            }).catch(() => {
                ModalNextProvider.showAlert({
                    title: documentMessages.documentDeletionFailed,
                    message: documentMessages.documentCannotDeleted,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: messages.ok
                }).catch(_.noop);
            }).finally(() => {
                setLoadingState(false);
            });
    }, [authHeader, bankVM, existingDocumentList, refreshData]);

    const isServicerEquestPresent = useCallback(
        () => {
            return ServiceRequestService.isServiceRequestAvailable(authHeader)
                .then((response) => {
                    isAddButtonDisabled(response);
                });
        },
        [authHeader],
    );

    const retrieveContactId = useCallback(
        () => {
            ServiceRequestService.retrieveTargetId_EXT(authHeader)
                .then((response) => {
                    // setTargetId(response);
                    ServiceRequestService.retrieveExistingPublicIds(response, authHeader)
                        .then((data) => {
                            data.forEach((value) => {
                                existingDocumentList.push(value);
                            });
                            setExistingDocumentList(existingDocumentList);
                        });
                });
        },
        [authHeader, existingDocumentList],
    );

    useEffect(() => {
        const list = _.get(bankVM, 'cardArray.value');
        if ((_.isEmpty(list) || _.isUndefined(list)) && fetched === false) {
            displayEFTRecords();
        }
        isServicerEquestPresent();
        //retrieveContactId();
        //retrieveExistingBankDocuments()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bankVM, displayEFTRecords]);

    const handleCancelButton = useCallback(
        () => {
            if (existingDocumentList.length > 0) {
                ModalNextProvider.showConfirm({
                    title: 'Warning',
                    message: 'You have added documents.Are you sure you want to cancel?',
                    status: 'warning',
                    icon: 'mi-error-outline',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                }).then(async (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }
                    setAddNewDetails(!addNewDetails);
                    if (!_.isEmpty(indexArray)) {
                        const accountNumber = _.get(bankVM, 'accountNumber').value;
                        const accountType = _.get(bankVM, 'accountType').value;
                        const branchCode = _.get(bankVM, 'branchCode').value;
                        const bankName = _.get(bankVM, 'bankName').value;
                        const isPrimary = _.get(bankVM, 'isPrimary').value;
                        const publicId = _.get(bankVM, 'publicId').value;
                        const accountName = _.get(bankVM, 'accountName').value;
                        const bankValue = {
                            accountNumber, accountType, branchCode, bankName, isPrimary, publicId, accountName
                        };
                        if (!_.isUndefined(indexArray) && !_.isEmpty(indexArray) && indexArray.length > 0) {
                            if (indexArray.includes(publicId)) {
                                bankDataArray.push(bankValue);
                                setBankDataArray(bankDataArray);
                                const updatedList = indexArray.filter((v) => v !== publicId);
                                setIndexArray(updatedList);
                            }
                        }
                    }
                    // return true;
                    window.location.reload(true);
                }, _.noop);
                // .finally(() => {
                //     window.location.reload(true);
                // });
            }
            else {
                setAddNewDetails(!addNewDetails);
                if (!_.isEmpty(indexArray)) {
                    const accountNumber = _.get(bankVM, 'accountNumber').value;
                    const accountType = _.get(bankVM, 'accountType').value;
                    const branchCode = _.get(bankVM, 'branchCode').value;
                    const bankName = _.get(bankVM, 'bankName').value;
                    const isPrimary = _.get(bankVM, 'isPrimary').value;
                    const publicId = _.get(bankVM, 'publicId').value;
                    const accountName = _.get(bankVM, 'accountName').value;
                    const bankValue = {
                        accountNumber, accountType, branchCode, bankName, isPrimary, publicId, accountName
                    };
                    if (!_.isUndefined(indexArray) && !_.isEmpty(indexArray) && indexArray.length > 0) {
                        if (indexArray.includes(publicId)) {
                            bankDataArray.push(bankValue);
                            setBankDataArray(bankDataArray);
                            const updatedList = indexArray.filter((v) => v !== publicId);
                            setIndexArray(updatedList);
                        }
                    }
                }
                window.location.reload(true);
            }
        },
        [addNewDetails, bankDataArray, bankVM, existingDocumentList.length, indexArray],
    );


    const deleteBankCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            var { publicId } = item;
            ModalNextProvider.showConfirm({
                title: 'Warning',
                message: 'Are you sure you want to remove this bank?',
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(async (results) => {
                if (results === 'cancel') {
                    return _.noop();
                }
                ServiceRequestService.deleteBankAccount_EXT(publicId, authHeader)
                    .then(() => {
                        const bankList = _.get(bankVM, 'cardArray.value');
                        bankList.splice((index), 1);
                        bankDataArray.splice((index), 1);
                        setBankDataArray(bankDataArray);
                        _.set(bankVM.value, 'cardArray', bankList);
                    });
                return true;
            }, _.noop)
                .finally(() => {
                    window.location.reload(true);
                });
        },
        [authHeader, bankDataArray, bankVM]
    );
    const editBankCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            //checkingAVSValidation();
            const bankList = _.get(bankVM, 'cardArray.value');
            bankList.splice((index), 1);
            setBankDataArray(bankList);
            _.set(bankVM.value, 'cardArray', bankList);
            //bankVM.value = item;
            const {
                bankName, accountType, accountNumber, accountName, branchCode, publicId, isPrimary
            } = item;
            setSelectedAccountType(accountType);
            setSelectedIsPrimary(isPrimary === 'Yes' ? true : false);
            displayBankNames();
            setSelectedBankName(bankName);
            //populateBankCode(bankName);
            _.set(bankVM, 'accountNumber', accountNumber);
            _.set(bankVM, 'accountName', accountName);
            _.set(bankVM, 'branchCode', branchCode);
            _.set(bankVM, 'publicId', publicId);
            _.set(bankVM, 'bankName', bankName);
            _.set(bankVM, 'accountType', accountType);
            setAddNewDetails(!addNewDetails);
            indexArray.push(publicId);
            setIndexArray(indexArray);
            //refreshData();
        },
        [addNewDetails, bankVM, checkingAVSValidation, displayBankNames, indexArray]
    );
    const encryptAccntNum = useCallback(
        (accNum) => {
            if (_.isUndefined(accNum) || _.isEmpty(accNum)) {
                return '';
            }
            else {
                return accNum.length <= 4 ? ((accNum.substring(0, 3)).concat('***')) : ((accNum.substring(0, 4)).concat('*****'));
            }
        },
        [],
    )

    const generateBankCardOverrides = useCallback(() => {
        const bankValueArray = _.get(bankVM.value, 'cardArray', []);
        const overrides = bankValueArray.map((elem, index) => {
            return {
                [`individualAccountNumber${index}`]: {
                    value: encryptAccntNum(elem.accountNumber)
                    //value: (elem.accountNumber && (_.isUndefined(elem.accountNumber) && elem.accountNumber.length <= 4) ? ((elem.accountNumber.substring(0, 3)).concat('***')) : ((elem.accountNumber.substring(0, 4)).concat('*****')))
                },

                [`deleteIncident${index}`]: {
                    onClick: (e) => {
                        deleteBankCard(e, elem, index);
                    }
                },

                [`editIncident${index}`]: {
                    onClick: (e) => {
                        editBankCard(e, elem, index);
                    }
                },
            };
        });
        return Object.assign({}, ...overrides);
    }, [bankVM.value, deleteBankCard, editBankCard, encryptAccntNum]);

    const overrideProps = {
        addNewBankComponent: {
            visible: addNewDetails === true
        },

        noServiceNotification: {
            visible: disableAddButton === false
        },

        sasriaBankNames: {
            availableValues: bankNamesArray,
            value: selectedBankName
        },

        gwAlertStatusHeading: {
            content: bankStatus
        },

        existingBankComponent: {
            visible: addNewDetails !== true
        },

        Cancellink: {
            trigger: handleCancelButton
        },

        AddButtonLink: {
            trigger: handleAddButton
        },

        newBankAccount: {
            disabled: disableAddButton === false
        },

        accountType: {
            value: selectedAccountType
        },
        primaryAccount: {
            value: selectedIsPrimary
        },

        fileUpload: {
            uploadDocument: handleUploadDocument,
            deleteDocument: handleDeleteDocument,
            downloadDocument: ServiceRequestService.downloadVendorDocumentLink_EXT,
            isLoading: isLoading
        },
        ...generateBankCardOverrides()
    };

    const refreshPage = useCallback(
        () => {
            window.location.reload(true);
        },
        [],
    );

    const resolvers = {
        resolveComponentMap: {
            documentcomponent: DocumentComponent,
        },
        resolveCallbackMap: {
            addBankAccount: addBankAccount,
            populateBankNames: populateBankNames,
            handleAccountType: handleAccountType,
            handlePrimaryAccount: handlePrimaryAccount,
            refreshPage: refreshPage
        },
        resolveClassNameMap: styles
    };

    const readValue = (id, path) => {
        return readViewModelValue(metadata.pageContent, bankVM, id, path, overrideProps);
    };
    // const readValue = useCallback(
    //     (fieldId, path) => {
    //         return readViewModelValue(
    //             metadata.pageContent,
    //             bankVM,
    //             fieldId,
    //             path,
    //             overrideProps
    //         );
    //     },
    //     [bankVM, overrideProps]
    // );


    // return <div>{renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers)}</div>;
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={bankVM}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            resolveValue={readValue}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

export default withRouter(SasriaBankDetailsPage);
